import { categoriesStep, dishesSteps, optionSteps } from 'common/constants/menu';

import { getErrorByKey } from 'utils';

export const errorsVariants = {
  menuDishes: 'menu-dishes',
  specialMenu: 'special-menu',
  dishOptions: 'dish-options',
  dishCategories: 'dish-categories',
};

class ErrorHelper {
  constructor(variant = errorsVariants.menuDishes) {
    this.variant = variant;
    this.initConfigs();
  }

  getInvalidSteps = (errors) => {
    if (!errors) return [];
    const errorsByStep = [];

    Object.keys(this.errorsKeyByStep).forEach(key => {
      const errorKey = this.errorsKeyByStep[key];
      errorKey.forEach(i => {
        if (getErrorByKey(errors, i)) {
          errorsByStep.push(key);
        }
      });
    });

    return errorsByStep;
  }

  initConfigs = () => {
    if (this.variant === errorsVariants.menuDishes) {
      this.steps = dishesSteps;
      this.errorsKeyByStep = {
        [dishesSteps.first]: ['title', 'title_it'],
        [dishesSteps.second]: ['dishes'],
        [dishesSteps.third]: ['price'],
        [dishesSteps.fourth]: ['visible_from', 'visible_to'],
        [dishesSteps.fifth]: ['valid_from', 'valid_to'],
      };
    }
    if (this.variant === errorsVariants.specialMenu) {
      this.steps = categoriesStep;
      this.errorsKeyByStep = {
        [categoriesStep.first]: ['title', 'title_it'],
        [categoriesStep.second]: ['special_menus_categories.dishes_special_menus'],
        [categoriesStep.third]: ['price'],
        [categoriesStep.fourth]: ['visible_from', 'visible_to'],
        [categoriesStep.fifth]: ['valid_from', 'valid_to'],
      };
    }
    if (this.variant === errorsVariants.dishOptions) {
      this.steps = optionSteps;
      this.errorsKeyByStep = {
        [dishesSteps.first]: ['title', 'title_it', 'description', 'price'],
        [dishesSteps.second]: ['can_be_chosen_count', 'mandatory'],
        [dishesSteps.third]: ['can_be_excluded'],
        [dishesSteps.fourth]: ['option_categories', 'option_categories.dish_category', 'option_categories.dishes'],
      };
    }
    if (this.variant === errorsVariants.dishCategories) {
      this.steps = categoriesStep;
      this.errorsKeyByStep = {
        [categoriesStep.first]: ['title', 'title_it', 'config.description', 'price'],
        [categoriesStep.second]: ['config'],
        [categoriesStep.third]: ['config.manufacturer_name'],
        [categoriesStep.fourth]: ['config.visible_from', 'config.visible_to'],
        [categoriesStep.fifth]: ['config.valid_from', 'config.valid_to'],
      };
    }
  }
}

export default ErrorHelper;
